import * as React from 'react';

import { useIntl } from 'react-intl';

import { PERMISSION } from 'src/features/auth/types';
import { GeneralBlockTitle } from 'src/registry/components/blocks/GeneralBlock';
import { Checkbox } from 'src/registry/ui/Checkbox';
import { Separator } from 'src/registry/ui/Separator';

type PermissionBlockProps = {
    title: string;
    rolePermissions: PERMISSION[];
    permissionValues: {
        value: PERMISSION;
        label: {
            defaultMessage: string;
            id: string;
        };
    }[];
    setRolePermissions: (permissions: PERMISSION[]) => void;
};

const PermissionBlock = ({ title, rolePermissions, permissionValues, setRolePermissions }: PermissionBlockProps) => {
    const { formatMessage } = useIntl();

    const handleCheck = React.useCallback(
        (value: PERMISSION) => {
            const newPermissions = rolePermissions.includes(value)
                ? rolePermissions.filter((a) => a !== value)
                : [...rolePermissions, value];
            setRolePermissions(newPermissions);
        },
        [rolePermissions, setRolePermissions],
    );

    return (
        <>
            <GeneralBlockTitle>{title}</GeneralBlockTitle>
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 xl:grid-cols-3">
                {permissionValues.map(({ value, label }) => {
                    return (
                        <div className="flex w-full flex-row items-center justify-start gap-2" key={value}>
                            <Checkbox
                                checked={rolePermissions.includes(value)}
                                onCheckedChange={() => handleCheck(value)}
                                id={value}
                            />
                            <label htmlFor={value}>{formatMessage(label)}</label>
                        </div>
                    );
                })}
            </div>
            <Separator />
        </>
    );
};

export default PermissionBlock;
